import React from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from 'recharts';
import timeHelper from '../helpers/time';



class CustomizedAxisTick extends React.PureComponent {
    render() {
      const { x, y, stroke, payload } = this.props;
      return (
           <b>{payload.value}</b>
      );
    }
  }

export default class PieChart extends React.PureComponent {
    constructor(props) {
        super(props);

        this.renderTooltip = this.renderTooltip.bind(this);
        this.renderXAxis = this.renderXAxis.bind(this);
    }

    _buildData(serviceName, serviceData) {
        return {
            name: serviceName,
            projectName: serviceData.projectName,
            [this.props.downBarTitle]: timeHelper.secondsToHour(serviceData[this.props.downBarKey]),
        }
    }

    renderTooltip({  payload }) {
        if (this.props.totalTimeSpent) {
            const totalTimeSpent = timeHelper.secondsToHour(this.props.totalTimeSpent);
            const percentageOfTime = timeHelper.calculatePercentaje(payload[0]?.value || 0, totalTimeSpent);

            return (
                <div className="custom-tooltip">
                    <p className="label">
                        {payload[0]?.payload?.projectName}:
                        <b>{payload[0]?.value} h.</b>
                    </p>
                    <p className="percentage">
                        Percentage of time: <b>{percentageOfTime}%</b>
                    </p>
                </div>
            )
        }

        return null
    }

    renderXAxis() {
        const { x, y, stroke, payload } = this.props;

        return (
            <g transform={`translate(${x},${y})`}>
                <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-35)">
                    {payload.value}
                </text>
            </g>
        );
    }
    render() {
        const data = Object.keys(this.props.data).map(serviceName => (
            this._buildData(serviceName, this.props.data[serviceName])
        ));
        const tickFormatter = (value) => {
            const limit = 25;

            if (value.toString().length < limit) return value;
            return `${value.toString().substring(0, limit)}...`;
        };
        const angle = data.length > 6 ? -90 : 0;

        return (
            <ResponsiveContainer width="90%" height="90%">
                <BarChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <Bar dataKey={this.props.downBarTitle} stackId="a" fill="#073763" />
                    <YAxis trick={<CustomizedAxisTick/>}/>
                    <Tooltip content={this.renderTooltip} />
                    <Legend />
                    <XAxis
                        dataKey="name"
                        angle={angle}
                        textAnchor="end"
                        tickFormatter={tickFormatter}
                        interval={0}
                        width={180}
                        height={180}
                        tickSize={10}
                    />
                </BarChart>
            </ResponsiveContainer>
        );
    }
}
